(function () {
  function isMobile() { return window.matchMedia('(max-width: 749px)').matches; }

  function initOne(root) {
    if (root.dataset.vheroInit) return;
    root.dataset.vheroInit = '1';

    var video = root.querySelector('.he-vhero__video');
    if (!video) return;

    var dsk = root.getAttribute('data-video-desktop') || '';
    var mob = root.getAttribute('data-video-mobile') || dsk;
    var posterD = root.getAttribute('data-poster-desktop') || '';
    var posterM = root.getAttribute('data-poster-mobile') || posterD;
    var altD = root.getAttribute('data-alt-desktop') || '';
    var altM = root.getAttribute('data-alt-mobile') || altD;
    var auto = root.getAttribute('data-autoplay') === 'true';

    if (isMobile()) {
      if (mob && mob !== dsk) {
        var source = video.querySelector('source');
        if (source) { source.setAttribute('src', mob); }
        video.load();
      }
      if (posterM) { video.setAttribute('poster', posterM); }
      if (altM) { video.setAttribute('aria-label', altM); }
    }

    if (auto) {
      video.muted = true;
      video.setAttribute('muted', '');
      video.removeAttribute('controls');
      root.classList.add('is-playing');
      var pa = video.play();
      if (pa && pa.catch) { pa.catch(function () {}); }
      return;
    }

    var started = false;
    function start() {
      if (started) return;
      started = true;
      root.classList.add('is-playing');
      video.muted = false;
      var p = video.play();
      if (p && p.catch) { p.catch(function () { video.muted = true; video.play(); }); }
    }
    video.addEventListener('click', function () { if (!started) start(); });
    video.addEventListener('play', function () { root.classList.add('is-playing'); });
  }

  function initAll() {
    var heroes = document.querySelectorAll('.he-vhero');
    for (var i = 0; i < heroes.length; i++) { initOne(heroes[i]); }
  }

  if (document.readyState !== 'loading') { initAll(); }
  else { document.addEventListener('DOMContentLoaded', initAll); }
  document.addEventListener('shopify:section:load', function () { initAll(); });
})();
